import type { components } from '@scanlab/api-types'

export type OrderDto = components['schemas']['OrderDto'];
export type OrderStatus = components['schemas']['OrderStatus'];
export type ErrorResponse = components['schemas']['ErrorResponse'];

export type ErrorType = 'no-code' | 'not-found' | 'network';

export class OrderApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string,
    public details?: any
  ) {
    super(message);
    this.name = 'OrderApiError';
  }
}


export interface OrderDiscount {
  discountAmount: string;
  discountValue: number;
  finalPrice: number;
  hasDiscount: true;
  originalPrice: number;
}
